import React, { useRef, useEffect, useCallback } from 'react';
import Swiper from 'swiper';
import { comfortContent } from './Comfort.content';
import arrow from '../HalfSlider/assets/arrow.svg';
import cloud from './assets/cloud.webp';
import styles from './Comfort.module.sass';
import 'swiper/dist/css/swiper.min.css';

export function Comfort() {
  const { title, subtitle, cards } = comfortContent;
  const containerRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    swiperRef.current = new Swiper(containerRef.current, {
      slidesPerView: 3.4,
      spaceBetween: 0,
      speed: 700,
    });

    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true);
        swiperRef.current = null;
      }
    };
  }, []);

  const handlePrev = useCallback(() => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (swiperRef.current) swiperRef.current.slideNext();
  }, []);

  return (
    <section className={styles.comfort}>
      <img src={cloud} alt="" className={styles.comfort__cloud} aria-hidden />

      <div className={styles.comfort__header}>
        <h2 className={styles.comfort__title}>
          {title.map((seg, i) => (
            <React.Fragment key={i}>
              {seg.accent ? (
                <span className={styles.comfort__titleAccent}>{seg.text}</span>
              ) : (
                seg.text
              )}
            </React.Fragment>
          ))}
        </h2>

        <div className={styles.comfort__headerRight}>
          <p className={styles.comfort__subtitle}>
            {subtitle.map((seg, i) => (
              <React.Fragment key={i}>
                {seg.accent ? (
                  <span className={styles.comfort__subtitleAccent}>{seg.text}</span>
                ) : (
                  seg.text
                )}
              </React.Fragment>
            ))}
          </p>
          <div className={styles.comfort__nav}>
            <button
              className={styles.comfort__navBtn}
              onClick={handlePrev}
              aria-label="Предыдущий слайд"
            >
              <img src={arrow} alt="" className={styles.comfort__navIcon} />
            </button>
            <button
              className={styles.comfort__navBtn}
              onClick={handleNext}
              aria-label="Следующий слайд"
            >
              <img
                src={arrow}
                alt=""
                className={`${styles.comfort__navIcon} ${styles['comfort__navIcon--right']}`}
              />
            </button>
          </div>
        </div>
      </div>

      <div className={`swiper-container ${styles.comfort__swiper}`} ref={containerRef}>
        <div className="swiper-wrapper">
          {cards.map((card, i) => (
            <div key={i} className={`swiper-slide ${styles.comfort__slide}`}>
              <div className={styles.comfort__card}>
                <div className={styles.comfort__cardImageWrap}>
                  <img src={card.image} alt="" className={styles.comfort__cardImage} />
                </div>
                <h3 className={styles.comfort__cardTitle}>
                  {card.title.map((seg, j) => (
                    <React.Fragment key={j}>
                      {seg.accent ? (
                        <span className={styles.comfort__cardTitleAccent}>{seg.text}</span>
                      ) : (
                        seg.text
                      )}
                      {j < card.title.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </h3>
                <div className={styles.comfort__cardText}>
                  {card.text.map((seg, j) => (
                    <p key={j} className={seg.accent ? styles.comfort__cardTextAccent : undefined}>
                      <span dangerouslySetInnerHTML={{ __html: seg.text }} />
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
